<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <div class="text-md-center">
          <h3>{{ version }} [{{ gitBranch }}]</h3>
          <h2>{{ errorCode }}</h2>
          <h3 class="my-3 headline ">{{ errorMessage }}</h3>
          <h5 class="my-3 headline ">{{ errorStack }}</h5>
          <div>
            En cas de persistence de l'erreur, merci d'appuyer sur ce bouton :
            <v-btn class="ml-2" small @click="resetPreferences">
              Réinitialiser mes préférences
            </v-btn>
          </div>
        </div>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'errorPage',
  data: () => ({
    version: 0,
    gitBranch: '',
  }),
  methods: {
    resetPreferences() {
      window.localStorage.clear();
      window.sessionStorage.clear();
      this.clearCookies();
      this.$router.push({ name: 'Root' });
    },
    clearCookies() {
      const cookies = document.cookie.split(';');

      for (let i = 0; i < cookies.length; i += 1) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      }
    },
  },
  computed: {
    errorCode() {
      try {
        return this.$route.params.errorCode;
      } catch (error) {
        return 'Authentification Error';
      }
    },
    errorMessage() {
      try {
        return this.$route.params.errorMessage;
      } catch (error) {
        return '';
      }
    },
    errorStack() {
      try {
        return this.$route.params.errorStack;
      } catch (error) {
        return '';
      }
    },
  },
  mounted() {
    this.version = process.env.PACKAGE_VERSION;
    this.gitBranch = process.env.CI_COMMIT_BRANCH;
  },
};
</script>
<style scoped lang="css">
h1 {
  font-size: 70px;
  line-height: 150px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
